import MultiFactor from "./MultiFactorLogin";

export default MultiFactor;
